"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { jsx, jsxs } from "react/jsx-runtime";
import Api from "../../api/api";
import reactUtils from "../../react_utils";
import Auth from "../../util/auth";
import { visibilityIcon, visibilityOffIcon } from "../ui/visibility_icons";
import ToolbarLink from "./toolbar_link";
import { markDuplicateIcon } from "../ui/mark_duplicate_icons";
const bem = reactUtils.makeBem("page-toolbar");
function iconLink(icon, enabled, action, href, title, active = false, label = null) {
  return /* @__PURE__ */ jsx(ToolbarLink, __spreadValues({}, { icon, enabled, action, href, title, active, label }));
}
function viewEmailButton(props) {
  const indexAuditSplitEnabled = Api.Account.currentSettings().index_audit_split_enabled;
  const title = indexAuditSplitEnabled ? "Re-Index" : "View Email";
  return /* @__PURE__ */ jsx(
    "a",
    {
      onClick: props.viewEmail,
      className: bem("__action_button", "__view_email"),
      title,
      children: title
    }
  );
}
function zoomInLink(props) {
  return iconLink(
    "zoom-in",
    props.canZoomIn,
    props.zoomIn,
    void 0,
    "Zoom In - Alt+= or +(Numpad)"
  );
}
function zoomOutLink(props) {
  return iconLink(
    "zoom-out",
    props.canZoomOut,
    props.zoomOut,
    void 0,
    "Zoom Out - Alt+- or -(Numpad)"
  );
}
function downloadAllLink(props) {
  if (props.downloadAllURL) {
    return iconLink(
      "page-export-pdf",
      true,
      void 0,
      props.downloadAllURL,
      "Download All Documents"
    );
  }
}
function downloadLink(props) {
  if (Auth.getCurrentUser().managed_indexer) return null;
  else {
    const enabled = !props.attachmentIsProcessing;
    return iconLink(
      "download",
      enabled,
      void 0,
      props.downloadURL,
      "Download Document"
    );
  }
}
function rotateLeftLink(props) {
  if (props.allowsEditing) {
    const enabled = !props.attachmentIsProcessing;
    return iconLink(
      "rotate-left",
      enabled,
      props.rotateLeft,
      void 0,
      "Rotate Left - Left Arrow Key"
    );
  }
}
function rotateRightLink(props) {
  if (props.allowsEditing) {
    const enabled = !props.attachmentIsProcessing;
    return iconLink(
      "rotate-right",
      enabled,
      props.rotateRight,
      void 0,
      "Rotate Right - Right Arrow Key"
    );
  }
}
function splitLink(props) {
  if (props.allowsEditing && props.canSplit) {
    return iconLink(
      "split-page",
      true,
      props.split,
      void 0,
      "Split From Document",
      false
    );
  }
}
function mergeLink(props) {
  if (props.allowsEditing && props.canMerge) {
    return iconLink(
      "merge-page",
      true,
      props.merge,
      void 0,
      "Merge to Previous",
      false
    );
  }
}
function duplicateLink(props) {
  if (props.allowsEditing) {
    return iconLink(
      "page-copy",
      true,
      props.duplicate,
      void 0,
      "Duplicate Document"
    );
  }
}
function annotateLink(props) {
  const settings = Api.Account.currentSettings();
  if (props.allowsEditing && settings.document_annotation_enabled) {
    return iconLink(
      "annotate",
      true,
      props.annotate,
      void 0,
      "Annotate Document",
      props.annotating
    );
  }
}
function illegibleButton(props) {
  if (props.canMarkIllegible) {
    return /* @__PURE__ */ jsxs(
      "a",
      {
        onClick: () => props.markIllegible(),
        className: bem("__action_button"),
        title: "Mark Illegible - Alt+T",
        children: [
          props.markedIllegible ? visibilityIcon() : visibilityOffIcon(),
          /* @__PURE__ */ jsx("span", { children: props.markedIllegible ? "Legible" : "Illegible" })
        ]
      }
    );
  }
}
function toggleHiddenButton(props) {
  if (props.canToggleHidden) {
    return /* @__PURE__ */ jsxs(
      "a",
      {
        onClick: () => props.toggleHidden(),
        className: bem("__action_button"),
        title: "Hide - Alt+H",
        children: [
          markDuplicateIcon(),
          /* @__PURE__ */ jsx("span", { children: "Hide" })
        ]
      }
    );
  }
}
function PageToolbar(props) {
  const showEmailButton = !!Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled;
  return /* @__PURE__ */ jsxs("div", { "data-component": "PageToolbar", className: bem("__bar"), children: [
    /* @__PURE__ */ jsxs("div", { className: bem("__action_icons"), children: [
      zoomInLink(props),
      zoomOutLink(props),
      downloadLink(props),
      downloadAllLink(props),
      duplicateLink(props),
      rotateLeftLink(props),
      rotateRightLink(props),
      splitLink(props),
      mergeLink(props),
      annotateLink(props)
    ] }),
    /* @__PURE__ */ jsxs("div", { className: bem("__action_buttons"), children: [
      illegibleButton(props),
      toggleHiddenButton(props),
      showEmailButton && viewEmailButton(props)
    ] })
  ] });
}
export default PageToolbar;
